import React from 'react';
import { Row, Col } from 'reactstrap';
import Aux from '../../hoc/Aux/Aux';
import MainMenu from '../Navigation/MainMenu/MainMenu';
import KeyVisual from '../UI/ResponsiveImageSet/ResponsiveImageSet';
import KeyVisualXs from '../../assets/images/keyvisual-xs-rgb.jpg';
import KeyVisualLg from '../../assets/images/keyvisual-lg-rgb.jpg';
import Countdown from './Countdown/Countdown';
import SeiteNichtGefundenLg from '../../assets/images/Seitenichtgefunden-lg-rgb.svg'
import SeiteNichtGefundenXs from '../../assets/images/Seitenichtgefunden-xs-rgb.svg'


const header = (props) => (
    <Aux>
        <Row className="sticky-top">
            <Countdown votingPhases={props.votingPhases}/>
        </Row>
        <Row>
            <Col className="p-0">
                <MainMenu primaryNavigation={props.primaryNavigation} primaryNavigationCTA={props.primaryNavigationCTA} />
            </Col>
        </Row>
        <Row>
            <Col className="px-0">
                {props.pageNotFound ? <KeyVisual imageXs={SeiteNichtGefundenXs} imageLg={SeiteNichtGefundenLg} /> : <KeyVisual imageXs={KeyVisualXs} imageLg={KeyVisualLg} />}
            </Col>
        </Row>
    </Aux>
);

export default header;
